<template>
	<div>
		<transition name="modal">
			<div class="modal"
			     style="display: block">
				<div class="modal-dialog"
				     role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h4 class="modal-title"
							    id="exampleModalLabel">
								{{$t('valutation.valutation_question_title')}}</h4>
							<button type="button"
							        class="close"
							        @click="closeModal()">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							{{$t('valutation.valutation_question_delete')}}
						</div>
						<div class="modal-footer">
							<button type="button"
							        class="btn btn-success abtg__default-button abtg__btn-default"
							        @click="closeModal()">
								{{$t('valutation.valutation_label_button_close')}}
							</button>
							<button type="button"
							        class="btn btn-success abtg__default-button abtg__btn-star"
							        @click="deleteRecord()"
							        data-dismiss="modal">{{$t('valutation.valutation_label_button_delete')}}
							</button>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>
<script>
	import { createHelpers } from 'vuex-map-fields'

	const { mapFields } = createHelpers({
		getterType: 'tvalutation/getField',
		mutationType: 'tvalutation/updateField',
	})

	export default {
		props: [''],
		components: {},
		data: function() {
			return {}
		},

		computed: {
			...mapFields([]),
		},
		created: function() {},
		methods: {
			deleteRecord: function() {
				this.$parent.deleteResource()
				this.closeModal()
			},

			closeModal: function() {
				this.$parent.closeModal()
			},
		},
	}
</script>